import { tabs } from '../../../../../../views/dashboard/company/CompanyDashboard';

export default {
  title: 'Panel',
  tabs: {
    [tabs.general]: 'General',
    [tabs.overview]: 'Resumen',
    [tabs.orders]: 'Pedidos por origen',
    [tabs.google]: 'Google',
    [tabs.customers]: 'Clientes',
    [tabs.order_conversion]: 'Conversión de pedidos',
    [tabs.mobile_app]: 'App móvil',
  },
  date_range: {
    this_month: 'Este mes',
    last_month: 'Mes pasado',
    last_week: 'Semana pasada',
    this_week: 'Esta semana',
    this_year: 'Este año',
    last_year: 'Año pasado',
    today: 'Hoy',
    yesterday: 'Ayer',
    all: 'Todo',
  },
  buttons: {
    view_key_info: 'Ver información clave',
  },
  empty_franchise: {
    description: 'Esta marca aún no tiene ningún restaurante. Elige otra marca en el menú para ver sus cifras.',
  },
};
